
class I96Menu {

    constructor(config = {}) {
        this.settings = {
            debug:      false,
            navMenuIsOpen: false,
            body:       document.querySelector('body'),
            nav:        document.querySelector('.i96-menu'),
            navBar:     document.querySelector('.nav--bar'),
            navToggle:  document.querySelectorAll('.nav--toggle'),
            navMenu:    document.querySelector('.nav--menu'),
            navMenuBG:  document.querySelector('.nav--menu-bg')
        }

        this.init();
    }

    init() {

        // adding the hamburger click event
        this.settings.navToggle.forEach( ele => {
            ele.addEventListener('click', e => {
                !this.settings.navMenuIsOpen ? this.showMenu() : this.hideMenu();
                // console.log('navMenuIsOpen', this.settings.navMenuIsOpen);
            });
        });


        // closing with ESC key
        document.addEventListener('keydown', e => {
            var keyboardKeyCode = e.keyCode,
                keyboardKey = e.key;

            switch(keyboardKeyCode) {
                case 27: // esc
                    if (this.settings.navMenuIsOpen) {
                        this.hideMenu();
                    }
                    break;
            }
        });


        // enable hover on touch
        // document.addEventListener('touchstart', function(){}, true);

    }

    showMenu() {
        this.settings.navMenuIsOpen = true;

        this.settings.body.classList.add('nav--is-visible');
        this.settings.navToggle.forEach( ele => {
            ele.classList.add('active');
        });
        this.settings.navMenu.classList.add('active');
        this.settings.navMenuBG.classList.add('active');
    }

    hideMenu() {
        this.settings.navMenuIsOpen = false;

        this.settings.body.classList.remove('nav--is-visible');
        this.settings.navToggle.forEach( ele => {
            ele.classList.remove('active');
        });
        this.settings.navMenu.classList.remove('active');
        this.settings.navMenuBG.classList.remove('active');
    }

}

export default I96Menu;
